import React, { useEffect } from "react";
import { Modal, Button } from "components/common";
import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { createRole, updateRole } from "redux/authorization/roleSlice";
import { useNavigate } from "react-router-dom";
import { FaBan, FaSave } from "react-icons/fa";

const RoleForm = ({ showModal, setshowModal, title, role }) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let roleId = role ? role.id : null;

  useEffect(() => {
    setValue('name', title === 'Edit Role' && role ? role.name : '');
  }, [role, title, setValue]);

  const onSubmit = async (data) => {
    try {
      if (role) {
        dispatch(updateRole({ roleId, data }));
      } else {
        const response = await dispatch(createRole(data));
        roleId = response.payload.data.id;
      }
      closeModal();
      navigate(`/authorization/roles/${roleId}`);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const closeModal = () => setshowModal(false);

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title={title}
      backdropClick={false}
      footer={
        <>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}><FaSave /> Save</Button>
          <Button variant="danger" onClick={closeModal}><FaBan /> Cancel</Button>
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-items-start tw-mb-3">
          <label className="tw-col-span-3 tw-text-sm tw-font-medium tw-text-gray-600 tw-text-right tw-pt-1.5">
            Name
          </label>
          <div className="tw-col-span-9">
            <textarea
              placeholder="Role name"
              autoComplete="role-name"
              rows={2}
              className="tw-w-full tw-border tw-border-gray-300 tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && <span className="tw-text-red-500 tw-text-xs">{errors.name.message}</span>}
          </div>
        </div>
      </form>
    </Modal>
  );
};

RoleForm.propTypes = {
  showModal: PropTypes.bool,
  setshowModal: PropTypes.func,
  title: PropTypes.string,
  role: PropTypes.object,
};

export default RoleForm;

